import { Turpial } from "./turpial";

/** Dispatch event on click outside of nodes */
export function clickOutside(node, parameter, container) {
  let nodes = [];
  let onClickedOutside = null;

  // Detect if called as a Svelte action or as a direct function
  const isAction = node instanceof HTMLElement;

  if (isAction) {
    // Svelte Action mode: use:clickOutside={parameter}
    nodes = [node];
    if (Array.isArray(parameter)) {
      nodes = [...nodes, ...parameter];
    } else if (parameter instanceof HTMLElement) {
      nodes.push(parameter);
    }

    // Default callback dispatches an event for Svelte actions
    onClickedOutside = (destroy, target) => {
      node.dispatchEvent(new CustomEvent('clickoutside', {
        detail: { target, destroy }
      }));
    };

    // If user passed a function, use it as direct callback
    if (typeof parameter === 'function') {
      onClickedOutside = parameter;
    }
  } else {
    // Legacy Function mode: clickOutside(nodes, onClickedOutside, container)
    nodes = Array.isArray(node) ? [...node] : [node];
    onClickedOutside = typeof parameter === 'function' ? parameter : function() {};
  }

  container = container ?? Turpial.$WindowObject.document_root ?? Turpial.$DocumentObject;

  const catchClick = function(event) {
    let hasBeenCliked = false;

    // Resolve string selectors
    const resolvedNodes = [...nodes];
    resolvedNodes.forEach((n, idx) => {
      if (typeof n === "string") {
        let new_nodes = [...container.querySelectorAll(n)];
        new_nodes.forEach((new_node) => {
          resolvedNodes.push(new_node);
        });
      }
    });

    resolvedNodes.forEach((n) => {
      if (!n || typeof n !== "object") return;
      if (n.contains && n.contains(event.target)) {
        hasBeenCliked = true;
      }
    });

    if (hasBeenCliked === false) {
      onClickedOutside(destroy, event.target);
    }
  };

  const destroy = function() {
    container.removeEventListener('click', catchClick, true);
  };

  container.addEventListener("click", catchClick, true);

  if (isAction) {
    return { destroy };
  }

  return destroy;
}